import React from "react";
import { AlertTriangle } from "lucide-react";

const Footer = () => {
  return (
    <footer className="relative border-t border-slate-800/70 bg-[#050b1f]">
      <div className="mx-auto max-w-4xl px-6 py-14 text-center">
        <div className="inline-flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-slate-300" />
          <h3 className="text-lg font-bold tracking-widest text-white">
            Disclaimer
          </h3>
        </div>
        <p className="mt-5 text-sm leading-relaxed text-slate-400">
          We are not registered financial advisors, and all content provided
          here is strictly for educational and informational purposes only. The
          information shared, including indicators, strategies, and market
          insights, is intended to help users enhance their understanding of
          trading concepts but should not be interpreted as financial advice.
          Trading involves significant risk, and past performance is not
          indicative of future results. Users are solely responsible for any
          financial decisions they make based on the content provided here. By
          using any indicators or strategies shared, you agree to our terms and
          conditions and acknowledge the associated risks. For any queries or
          support, please reach out to us at{" "}
          <a
            href="https://t.me/IndicatorSetup"
            target="_blank"
            rel="noreferrer"
            className="text-sky-400 hover:text-sky-300 underline underline-offset-2"
          >
            @IndicatorSetup
          </a>
          . Always trade responsibly and consult with a licensed professional
          if needed.
        </p>
      </div>
      <div className="border-t border-slate-800/70 py-6 text-center text-xs text-slate-500">
        © 2024 Swift AI Indicator · All Rights Reserved
      </div>
    </footer>
  );
};

export default Footer;
